import { useQuery } from '@tanstack/react-query';
import type { StockLocationsAPIResponse } from '../api/stock-locations/types';
import { useHandlers } from '../context/page-context';

const STOCK_LOCATIONS_QUERY_KEY = ['get-stock-locations'];

export type { StockLocationsAPIResponse };

export function useStockLocations() {
  const { apis } = useHandlers();

  async function fetchStockLocations() {
    return await apis.stockLocations.list();
  }

  const query = useQuery<StockLocationsAPIResponse[]>({
    queryKey: STOCK_LOCATIONS_QUERY_KEY,
    queryFn: fetchStockLocations,
  });

  return {
    stockLocations: query.data ?? [],
    refetch: query.refetch,

    isRefetching: query.isRefetching,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
